import { Component } from '@angular/core';
import { AsyncPipe, CommonModule, NgIf } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

@Component({
	selector: 'appshell-admin-link-overview-link-issue-modal',
	standalone: true,
	imports: [CommonModule, NgIf, AsyncPipe],
	templateUrl: './admin-link-overview-link-issue-modal.component.html',
	styleUrl: './admin-link-overview-link-issue-modal.component.scss',
})
export class AdminLinkOverviewLinkIssueModalComponent {
  public title: string = "Link issue report"
  public visibleSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)

  public issues: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([])

  constructor() { }

  ngOnInit(): void {

  }

  close() {
    this.visibleSubject.next(false)
  }

  open(issues: any[]) {
    this.issues.next(issues);
    this.visibleSubject.next(true);
  }

}
